import * as Yup from 'yup'
import { formatPhoneToInput } from '../helpers/util'

export const getInitialValues = ({ first_name, email, last_name, phone }) => ({
    first_name: first_name || '',
    email: email || '',
    last_name: last_name || '',
    phone: formatPhoneToInput(phone) || '',
})

export const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
    phone: Yup.string()
        .matches(
            /\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}/g,
            'Phone number is not valid',
        )
        .required('Phone is required'),
    last_name: Yup.string().required('Last Name is required'),
})
